var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26891 10.8319C8.26891 12.0196 8.54902 12.9608 9.10924 13.6555C9.66947 14.3501 10.4202 14.6975 11.3613 14.6975C12.3137 14.6975 13.0644 14.3557 13.6134 13.6723C14.1625 12.9776 14.437 12.0308 14.437 10.8319C14.437 9.63305 14.1625 8.68627 13.6134 7.9916C13.0644 7.29692 12.3081 6.94958 11.3445 6.94958C10.3922 6.94958 9.64146 7.29692 9.09244 7.9916C8.54342 8.68627 8.26891 9.63305 8.26891 10.8319ZM17.3277 18.0756L14.9412 19L11.6134 16.6471H11.3613C9.73669 16.6471 8.43697 16.1148 7.46218 15.0504C6.48739 13.986 6 12.5798 6 10.8319C6 9.07283 6.48179 7.66106 7.44538 6.59664C8.42017 5.53221 9.71989 5 11.3445 5C12.9916 5 14.2969 5.53221 15.2605 6.59664C16.2241 7.64986 16.7059 9.06162 16.7059 10.8319C16.7059 12.0644 16.4594 13.1345 15.9664 14.042C15.4734 14.9496 14.7787 15.6275 13.8824 16.0756L17.3277 18.0756Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.fdd5079e61774d5a2cc7e822c4d44fde.svg";
export { ForwardRef as ReactComponent };